import React from 'react';
import { useIntl } from 'react-intl';
import './index.scss';
import { LocalSessionInfo } from 'types';
import { translationWithErrorHandling } from '../../../../translation/handleMissingTranslation';

type Props = {
	isVisible: boolean;
	isSessionStarting: boolean;
	isSessionInitializing: boolean;
	robot: LocalSessionInfo['robot'];
	onClickEndSession: () => void;
};

export default function ConnectingSessionOverlay({
	onClickEndSession,
	isVisible,
	isSessionStarting,
	isSessionInitializing,
	robot,
}: Props) {
	const intl = useIntl();
	return isVisible ? (
		<div
			className={`starting-session-container ${
				isSessionInitializing ? 'starting-session-container-initializing' : ''
			}`}
		>
			{/* <div className="loading-indicator" /> */}

			<div className="title">
				{translationWithErrorHandling(intl, 'startingSession.connecting')}
			</div>
			<div className={`message ${!isSessionInitializing && isSessionStarting ? 'hidden' : ''}`}>
				{translationWithErrorHandling(intl, 'startingSession.yourSessionIsConnectingTo')}{' '}
				{robot.name}
			</div>
			<div className="end-session-button" onClick={() => onClickEndSession()}>
				{translationWithErrorHandling(intl, 'startingSession.endSession')}
			</div>
		</div>
	) : null;
}
